/**
 * Whether a list already has at least one copywriting campaign.
 *
 * Different list endpoints surface this differently: the full/single-lean fetches carry the
 * `campaignConfig` JSON, while the lean overview rows carry only the projected `campaignCount`.
 * So both are checked. `campaignConfig` is keyed by campaign uuid but can also carry a non-campaign
 * `name` key (see ListEditCopywriting's `tableData` derivation), which is ignored. `campaignCount`
 * may arrive as a string at runtime (SQL aggregate), so it is coerced before comparison.
 */
export const listHasCampaigns = (
	list:
		| {
				// `campaignConfig` is `z.any()` in the list schema, so it arrives loosely typed here.
				campaignConfig?: Record<string, unknown> | null;
				campaignCount?: number | null;
		  }
		| null
		| undefined
): boolean => {
	if (!list) {
		return false;
	}

	if (list.campaignConfig) {
		return Object.keys(list.campaignConfig).some((key) => key !== "name");
	}

	return Number(list.campaignCount ?? 0) > 0;
};
